// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Id_bB","comment":"styles_comment__2LV5_"};